<template>
  <div v-if="this.$route.params.farm_id && this.$route.params.farm_id !== '-1'" class="blank-table">
    <div class="table-head">
      <div class="table-head__title item w1">{{ 'base.farm_name' | translate }}</div>
      <div class="table-head__title item w2">{{ 'base.company' | translate }}</div>
    </div>
    <v-table-body
      v-if="loaded"
      outsideTable
      :empty="!additionals.length">
      <blank-item
        v-for="item in additionals"
        :key="item.id"
        :item="item"/>
    </v-table-body>
    <blank-item-skeleton v-else/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import BlankItem from './BlankItem'
import BlankItemSkeleton from './BlankItemSkeleton'

export default {
  name: 'Blanks',

  components: {
    BlankItem,
    BlankItemSkeleton
  },

  mounted () {
    if (this.allowView) {
      this.loadData()
    } else {
      this.loaded = true
    }
  },

  data: () => ({
    loaded: false,
    isToggled: false
  }),
  watch: {
    '$route.params.farm_id': {
      handler: 'loadData',
      immediate: true
    }
  },
  methods: {
    ...mapActions('additional', [
      'loadAdditionals'
    ]),

    async loadData () {
      if (!this.$route.params.farm_id || this.$route.params.farm_id === '-1') {
        this.loaded = false
        return
      }
      const filters = {
        farm: this.$route.params.farm_id
      }
      await this.loadAdditionals(filters)
      this.loaded = true
    }
  },

  computed: {
    ...mapGetters('additional', [
      'additionals'
    ]),

    path () {
      return this.$route.path
    },

    allowView () {
      return this.hasPermission('additional', 'view')
    }
  }
}
</script>

<style lang="scss" scoped>
  .w1 { width: 50%; }
  .w2 { width: 50%; }

  .table-head {
    display: flex;
    padding: 15px 20px;
    background: #fff;
    margin-bottom: 12px;
    color: #979797;
    font-size: 13px;

    &__title {
      font-size: 1.5rem;
    }
  }
</style>
